export const siteLogo = {
  logo: "../assets/images/wonted-logo.png",
  alt: "Wonted"
};

export const socialLink = {
  facebook: "https://www.facebook.com",
  twitter: "https://twitter.com/elaammari_",
  linkedin: "https://www.linkedin.com/in/abderrahman-elaammari-6905b7228",
  youtube: "https://www.youtube.com",
  whatsapp: "https://www.whatsapp.com",
};